(function ($) {
}(window.jQuery));

jQuery(($) => {
    function paginate (url) {
        $('.ajax-loader').show();
        $('.ajax-list-holder').hide();

        if ($('.news-ajax-list-holder').length > 0) {
            $('.news-ajax-list-holder').load(url, () => {
                $('html, body').animate({
                    scrollTop: $('.news-ajax-list-holder').offset().top
                });

                $('.ajax-loader').hide();
                $('.ajax-list-holder').show();

                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
            });
        } else if ($('.resource-ajax-list-holder').length > 0) {
            $('.resource-ajax-list-holder').load(url, () => {
                $('html, body').animate({
                    scrollTop: $('.resource-ajax-list-holder').offset().top
                });

                $('.ajax-loader').hide();
                $('.ajax-list-holder').show();

                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
            });
        } else {
            $('.ajax-list-holder').load(url, () => {
                $('html, body').animate({
                    scrollTop: $('.ajax-list-holder').offset().top
                });

                $('.ajax-loader').hide();
                $('.ajax-list-holder').show();

                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
            });
        }
    }

    function getPagination () {
        if ($('body.Education-Tec-Model-FundFinderPage').length) {
            return; // Fund Finder handles its own pagination in fund-finder.js
        }

        $('.ajax-list-holder').on('click', '.ajax-page a ', function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            paginate(url);
        });

        if ($('.pagination').length) {
            window.onpopstate = function (e) {
                if (e.state && e.state.url) {
                    paginate(e.state.url);
                } else {
                    e.preventDefault();
                }
            };
        }
    }

    getPagination();
});



// WEBPACK FOOTER //
// ./src/js/app/pagination.js